import React from 'react';
import Back from '@material-ui/icons/KeyboardBackspace';
import src from '../../../images/progress.png';

class Welcome extends React.Component {

    render() {
        const { intl, steps, step, valids } = this.props;
        const done = valids.reduce((total, i) => { if(i) { total = total + 1} return total;}, 0);
        const percentage = Math.round((1 / steps.length) * done * 100);
        const style = {
            backgroundSize: percentage + '% auto',
            backgroundRepeat: 'repeat-y',
            backgroundImage: 'url(' + src + ')',
            backgroundPositionY: 'center',
        }

        return (
            <div className="ob_steps">
                <div className="ob_back_row align_center " onClick={this.props.goTo(step - 1)}>
                    <Back className="margin_right_6" />
                    <span className="ob_back">
                        { intl.formatMessage({ id: 'ob_back' }) }
                    </span>
                </div>
                <div className="flex_full_column margin_top_32 padding_left_12 padding_right_12">
                    <span>{ percentage + "% completado"}</span>
                    <div className="ob_steps_progress" style={style} />
                    <ul className="ob_steps_ul flex_auto_column text_align_left padding_0 margin_left_24">
                        {steps.map((s, index) => 
                            <li key={"steps-" + s.step} className={"flex_auto_row align_center hand " + (valids[index] ? 'valid' : ' ')} onClick={this.props.goTo(s.step)}>
                                <span className={"ob_steps_li " + (s.step === step ? ' ob_blod' : ' ') }>
                                    { intl.formatMessage({ id: s.label }) }
                                </span>
                            </li>
                        )}
                    </ul>
                </div>
                <div className="ob_steps_info">
                    <b>Estamos para ayudarte.</b> 
                    Utiliza todas las ayudas disponibles para poder sacar el máximo partido a Iflares. 
                    Si necesitas asesoramiento, por favor, escríbenos a <a href="mailto://formacion@iflares.com">formacion@iflares.com</a>
                </div>
            </div>
        );
    }
}

export default Welcome;


// WEBPACK FOOTER //
// ./src/components/complex/onboarding/steps.js